import { render } from "./CreateInternationalCompetitionModal.vue?vue&type=template&id=22a53851&ts=true"
import script from "./CreateInternationalCompetitionModal.vue?vue&type=script&lang=ts"
export * from "./CreateInternationalCompetitionModal.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__